module.exports = __webpack_public_path__ + "static/img/6.6fa7791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/6.jpg
// module id = b9zc
// module chunks = 13